<template>
  <div class="development">
    <Header></Header>
    <slideshow></slideshow>
    <div class="content">
      <div class="content_left">
        <el-tabs :tab-position="tabPosition" v-model="Name">
          <!-- <el-tab-pane label="资讯中心" name="1">
            <div class="zxlist">
              <div class="Company_box">
                <p class="Company_text">资讯中心</p>
                <div class="arrow-right">
                  <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/' }"
                      >你现在所在的位置</el-breadcrumb-item
                    >
                    <el-breadcrumb-item :to="{ path: '/' }"
                      >首页</el-breadcrumb-item
                    >
                    <el-breadcrumb-item>咨询中心</el-breadcrumb-item>
                  
                  </el-breadcrumb>
                </div>
              </div>
              <div class="xiangqing">
                <div
                  style="line-height: 2"
                  v-for="(item, index) in list"
                  :key="index"
                >
                  <p
                    class="lszt"
                    style="font-size: 16px"
                    @click="xqy(item.id, item.bid,1,)"
                  >
                    {{ item.title }}
                  </p>
                  <p style="font-size: 16px">{{ item.addtime }}</p>
                  <div class="changwz" v-html="item.fu_title"></div>
                  <p class="xhx"></p>
                </div>

                <pagination
                  v-show="total > 0"
                  :total="total"
                  :page.sync="listQuery.pageNum"
                  :limit.sync="listQuery.pageSize"
                  @pagination="getShowLists"
                />
              </div>
            </div>
          </el-tab-pane> -->
         <el-tab-pane label="公司新闻" name="2">
            <Company></Company>
          </el-tab-pane>
          <el-tab-pane label="行业新闻" name="3">
            <Lndustry></Lndustry>
          </el-tab-pane>
          <el-tab-pane label="媒体聚焦" name="4">
            <Media></Media>
          </el-tab-pane>
          <el-tab-pane label="投资者问答" name="5">
            <Investor></Investor>
          </el-tab-pane>
          <el-tab-pane label="股价走势" name="6">
            <Stocks></Stocks>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <Footer></Footer>
  </div>
</template>
<script>
import pagination from "../../components/haed/pagination";
import Header from "../../components/haed/haed";
import Footer from "../../components/haed/footer";
import slideshow from "../../components/haed/slideshow";
import News from "../../components/haed/news";
import Investor from "../../components/investor";
import Stocks from "../../components/haed/stocks";
import Lndustry from "../../components/haed/Industry";
import Company from "../../components/haed/company";
import Media from "../../components/media";
import qs from "qs";
import axios from "axios";
export default {
  name: "development",
  components: {
    Header,
    Footer,
    slideshow,
    News,
    Investor,
    Stocks,
    pagination,
    Lndustry,
    Company,
    Media
  },
  data() {
    return {
      listQuery: {
        bsId: "",
      
        pageNum: 1,
        pageSize: 3,
      },
        Name:"2",
        go:"",
      tabPosition: "left",
      total: 9,
      list: [],
      title: "",
    };
  },
  created() {
    var go = this.$route.query.go;
    this.go=this.$route.query.go;
    // this.showList(go);
    if(this.$route.query.name){
      this.Name=this.$route.query.name
    }
  },
  mounted() {},
  methods: {
    xqy(id, bid,name) {
      this.$router.push({ path: "/Companynews?id=" + id + "&bid=" + bid +"&name="+name});
    },
    Company() {
      this.$router.push({ path: "/index" });
    },
    // getShowLists() {
    //    var go = this.$route.query.go;
    //   this.showList(go);
    // },
    // showList: function (go) {
    //   this.$axios({
    //     method: "post",
    //     url: "/index.php/news/newslist",
    //     data: qs.stringify({
    //       id: go,
    //       pageNum: this.listQuery.pageNum,
    //       pageSize: 5,
    //     }),
    //   })
    //     .then((res) => {
    //       this.list = res.data.data;
    //       this.total = res.data.datanum;
    //     })
    //     .catch((res) => {});
    // },
  },
};
</script>
<style scoped>


.pagination-container {
  margin-bottom: 5%;
}
.xhx {
  background-color: #cccccc;
  width: 100%;
  height: 1px;
  /* margin: 2% 0; */
}
.changwz {
  color: #0d3d3d;
  font-size: 16px;
}
.lszt {
  color: #1592e6;
  cursor: pointer;
  /* color: #Eee; */
}
.zxlist {
  margin-left: 40px;
}
.Company_text {
  font-weight: bold;
  font-size: 32px;
  color: #0c47a1;
  text-align: center;
  line-height: 2vw;
  margin-left: 10px;
  margin-top: -0.5vw;
}
.Company_box {
  display: flex;
  width: 100%;
  height: 2vw;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  margin-top: 10px;
  border-bottom: 1px solid #dedede;
}
.content {
  display: flex;
  margin-top: 60px;
}
.content_left {
  width: 1000px;
  margin: auto;
}
.el-tabs__item {
  font-size: 24px !important;
  height: 50px !important;
}
.el-tabs--left .el-tabs__item.is-left {
  font-size: 24px !important;
  height: 50px !important;
}
.xiams {
  position: relative;
  top: 160%;
  left: 250%;
  width: 1px;
  height: 6vw;
  background-color: #dedede;
}
.el-breadcrumb {
  font-size: 0.9vw;
  margin-top: 1%;
}
.Company_texts {
  font-weight: bold;
  font-size: 27px;
  color: #0c47a1;
  text-align: center;
  line-height: 2;
  margin-left: 10px;
  margin-top: -0.4vw;
}
.arrow-right {
  margin-top: 0.2vw;
}
.arrow-rights {
  margin-top: 2%;
  margin: 0 auto;
}
.fanhui {
  display: flex;
  width: 6vw;
  height: 3vw;
  text-align: center;
  line-height: 3vw;
  color: #cccccc;
  font-size: 1vw;
  position: absolute;
  z-index: 9999;
}
.imgs {
  width: 6vw;
  height: 1.5vw;
  position: relative;
  top: 190%;
  left: 210%;
}
.imgs:hover {
  cursor: pointer;
}
.imgs img {
  width: 100%;
  height: 100%;
}
.Company_boxs {
  display: flex;
  width: 50%;
  margin: 0 auto;
  margin-top: 2%;
  border-bottom: 1px solid #dedede;
}
.news_box {
  width: 55%;
  margin: 0 auto;
  margin-top: 2%;
}
.user_text {
  text-align: center;
  font-size: 24px;
}
.item_text {
  margin-top: 1%;
  color: #3d3d3d;
  text-align: center;
}
.content_text {
  width: 50%;
  margin: 0 auto;
  margin-top: 1%;
  margin-bottom: 1%;
  line-height: 1.5;
}
.arrow-rights {
  margin-top: 1%;
}
</style>
<style>
.el-tabs--left .el-tabs__item.is-left {
  font-size: 24px;
  padding-right: 20px;
}
</style>


// WEBPACK FOOTER //
// src/pages/listTitle/listTitle.vue